import React from 'react';
import clsx from 'clsx';

import cpdCertificateItemStyles from '../CPDCertificateItem/styles.module.scss';
import cpdCertificatesStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const Skeleton: React.FunctionComponent = () => {
  const classNames = clsx(
    styles.skeleton,
    cpdCertificatesStyles.cpdCertificates,
  );
  return (
    <React.Fragment>
      <span data-nosnippet className="visuallyHidden">
        Loading your cpdCertificates
      </span>
      <section className={classNames} aria-hidden="true">
        <p></p>
        <ul>
          <li className={cpdCertificateItemStyles.cpdCertificateItem}>
            <span></span>
            <div>
              <div></div>
              <p></p>
            </div>
            <hr />
            <div>
              <span></span>
              <em></em>
              <div></div>
            </div>
          </li>
          <li className={cpdCertificateItemStyles.cpdCertificateItem}>
            <span></span>
            <div>
              <div></div>
              <p></p>
            </div>
            <hr />
            <div>
              <span></span>
              <em></em>
              <div></div>
            </div>
          </li>
          <li className={cpdCertificateItemStyles.cpdCertificateItem}>
            <span></span>
            <div>
              <div></div>
              <p></p>
            </div>
            <hr />
            <div>
              <span></span>
              <em></em>
              <div></div>
            </div>
          </li>
          <li className={cpdCertificateItemStyles.cpdCertificateItem}>
            <span></span>
            <div>
              <div></div>
              <p></p>
            </div>
            <hr />
            <div>
              <span></span>
              <em></em>
              <div></div>
            </div>
          </li>
        </ul>
        <div>
          <span></span>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Skeleton;
